import { type JournalNote, createJournalNote } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getJournalContentObjects } from '../services';
import { getJournalFeedInfiniteQueryKey } from './keys';

type P = {
  limit: number;
};

export const useJournalFeedInfiniteQuery = ({ limit }: P) =>
  useInfiniteQuery<JournalNote[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getJournalContentObjects({
        config: {
          params: {
            cursor,
            limit,
          },
        },
      });

      // Not every journal has a post. Journals without a post are skipped until non-post journals can be shown.
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- False positive, because we have broken data in BE and post is not really there sometimes
      return data.filter((journalNote) => journalNote.post).map((journalNote) => createJournalNote(journalNote));
    },
    getNextPageParam: (lastPage) => (lastPage.length < limit ? undefined : lastPage.at(-1)?.id),
    initialPageParam: undefined,
    queryKey: getJournalFeedInfiniteQueryKey({}),
  });
